<template>
  <v-card flat color="section">
    <v-card-title>Security </v-card-title>
    <v-card-text class="pb-0">
     {{ subtitle }}
    </v-card-text>
    <v-card-text>
      <v-row class="ma-0">
        <v-col cols="12" lg="4" md="6">
          <security-two-factor-enrollment />
        </v-col>
        <v-col v-if="canChangePassword" cols="12" lg="4" md="6">
          <security-change-password />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script setup>
import SecurityChangePassword from "@/components/settings/security/SecurityChangePassword.vue";
import SecurityTwoFactorEnrollment from "@/components/settings/security/SecurityTwoFactorEnrollment.vue";
import { useUserStore } from "@/stores/user";
import { computed } from "vue";
import { storeToRefs} from "pinia"
const user = useUserStore()
const {sso_authenticatable} = storeToRefs(user)

const canChangePassword = computed(() => !sso_authenticatable.value)
const subtitle = computed(() => {

  let text = "Manage your Multi-Factor Authentication (MFA)"
  if(canChangePassword.value) text += "and your Password"
  return text
})

</script>
